import { HTTP_METHOD_POST } from '../../constants/httpMethod';
import { REQUEST_LYZI_PAY, SUCCESS_LYZI_PAY, FAILURE_LYZI_PAY } from './constants';

import { CALL_API } from '../../middlewares/api';
import gtm from '../../utils/gtmUtils';

export function payWithLyzi(userInfo, partnerId, orderId) {
    let plebicardUrl = `/public/payment-solution/lyzi/pay?email=${userInfo.email}`;
    plebicardUrl = userInfo.userId
        ? plebicardUrl.concat(`&userId=${userInfo.userId}`)
        : plebicardUrl;
    plebicardUrl = userInfo.clickId
        ? plebicardUrl.concat(`&clickId=${userInfo.clickId}`)
        : plebicardUrl;

    return {
        [CALL_API]: {
            endpoint: plebicardUrl,
            method: HTTP_METHOD_POST,
            body: { ...userInfo, partnerId, orderId },
            types: [REQUEST_LYZI_PAY, SUCCESS_LYZI_PAY, FAILURE_LYZI_PAY],
            finallyCallback: () => {
                gtm.event('add_payment_info', { payment_method: 'Lyzi' });
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/lyzi/actions.js